import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@fluentui/react';

import './FailedInvitation.scss';

export interface Props {
    message: string | undefined;
}

const FailedInvitation: FC<Props> = (props: Props) => {
    const { t } = useTranslation(['resources']);
    const { message } = props;
    return (
        <div className="ExpContent">
            <div>
                <div className="h-expired">
                    <Icon iconName="Info" className="ms-IconInfo" />
                    <span>{t('form-components.SorryMessage')}</span>
                </div>
            </div>
            <div className="contentexpired">
                <span>{message}</span>
            </div>
            <div className="contentexpired">
                <h6>{t('form-components.SorryMessage2')}</h6>
                <p>{t('form-components.SorryMessage3')}</p>
                <p>{t('form-components.SorryMessage4')}</p>
            </div>
            <div>
                <p>{t('form-components.SorryMessage5')}</p>
            </div>
        </div>
    );
};

export default FailedInvitation;
